import { gql } from "@apollo/client";

export const UPDATE_STUDENT_PROFILE_PHOTO_MUTATION = gql`
  mutation UpdateStudentProfilePhoto($personId: ID!, $profilePhotoUrl: String!, $universityLegacyId: ID) {
    updateProfilePhoto(
      personId: $personId
      profilePhotoUrl: $profilePhotoUrl
      universityLegacyId: $universityLegacyId
    ) {
      success
      message
      code
      person {
        id
        profilePhoto
      }
    }
  }
`;
